<template>
  <div class="hero-section-blog" :style="{ backgroundImage: 'url(' + cover + ')' }">
    <div class="shade"></div>
    <div class="main-container">
      <div class="info-content">
        <div class="info-top">
          <div class="blog-page-title heading-1">
            {{ fields.field_one.value.text }}
          </div>
          <div class="blog-page-content heading-3-regular">
            {{ fields.field_one.value.text2 }}
          </div>
        </div>
<!--        <div>-->
<!--          <div class="blog-page-content heading-3-regular">-->
<!--            {{ fields.field_one.value.text3 }}-->
<!--          </div>-->
<!--          <seu-email-input-->
<!--            :placeholder="fields.field_one.value.placeholder"-->
<!--            :button-label="fields.field_one.value.buttonLabel"-->
<!--          />-->
<!--        </div>-->

      </div>

    </div>
  </div>
</template>

<script>
import SbcButton from "/seu-frontend/components/SeuButton";
import SeuEmailInput from "/seu-frontend/components/SeuEmailInput";
import {isMobile} from "/seu-frontend/services/utils";

export default {
  name: 'HeroSectionBlog',
  components: {SeuEmailInput, SbcButton},
  props: {
    fields: {
      type: Object,
      required: true
    }
  },

  computed: {
    cover() {
      if(this.isMobile) {
        return this.fields.field_one.value.image_mobile
      }
      return this.fields.field_one.value.image
    }
  },

  data: () => ({
    isMobile: isMobile()
  })

}
</script>

<style lang="scss">
@import "HeroSectionBlog.scss";
</style>
